module.exports = __webpack_public_path__ + "static/media/gigger-signup.eeb8005f.svg";